import { render, staticRenderFns } from "./Mailgun.vue?vue&type=template&id=1a94547b&scoped=true&"
import script from "./Mailgun.vue?vue&type=script&lang=js&"
export * from "./Mailgun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a94547b",
  null
  
)

export default component.exports